import { Link } from "react-router-dom";
import { VerticalMenuItem } from "../components/containers/verticalMenu/VerticalMenuItem";
import { List } from "../components/elements/list/List";
import { Select } from "../components/elements/Select";
import { ShowMessage } from "../components/UI/showMessage/ShowMessage";
import { TexTranslate, TexTranslateDefault } from "../translations/FlattenMessages";
import { useLoader } from "./useLoader";
import { processResponseLoginCore } from "./useLoginCore";
import _ from "underscore";
import SelectableList from '../components/elements/list/SelectableList'
import { RedirectInvalidUser } from "../service/authServices";

export const useMenu = ({ setIdMenu, setIdSubMenu, setPrincipalMenu, intl,
    app, user, setLoginResponse, setDataObject, loginCore }) => {

    const txtLoad = TexTranslateDefault(intl, "general.Loading...");
    const {showLoader, hideLoader} = useLoader({"textLoader" : txtLoad});

    const selectMenu = (idMenu, idSubMenu) => {
        const currentMenu = idMenu !== null ? idMenu : "menuDashboard";
        setIdMenu(currentMenu);
        switch (currentMenu) {
            case "menuProviders":
            case "menuClients":
            case "menuTools":
                setPrincipalMenu?.(false);
                idSubMenu !== null && setIdSubMenu?.(idSubMenu);
                break;
            case "menuDashboard":
            case "menuPerfil":
            case "menuOut":
                setPrincipalMenu?.(true);
                setIdSubMenu?.(null);
                break;
            default:
                break;
        }
    };

    

    const createListMenu = (data, group, subGroup, tittle, handlerClickMenu) => {
        const dataList = getSubGroupMenu(data, group, subGroup);
        const menuListInit = [];
        for (const serv of dataList) {
            const objMenu = {
                "id": serv.idServicio,
                "servicio": serv.servicio,
                "text": TexTranslateDefault(intl, `module.${serv.servicio}`)
            };
            menuListInit.push(objMenu);
        }

        const menuList = _.sortBy(menuListInit,"text");

        const handleClickListItem = (selectedItem) => {
            showLoader();
            setDataObject(selectedItem);
            loginCore({ "setData" : setLoginResponse });
            
        };

        const menuComponent = <SelectableList arrayItems={menuList} handleClick={handleClickListItem} />;
        const result = {
            "text": tittle,
            "content": menuComponent,
            "clicMenu" : handlerClickMenu
        };

        return result;
    };

    const processLoginCoreMenu = ({loginResponse,dataObject}) => {
        if (loginResponse?.success) {
            const idiomaSesion = sessionStorage.getItem("idioma");
            RedirectInvalidUser();
            window.location.href = `${app.apiCore}/AdminEx.jsp?lang_user=${user.idioma || idiomaSesion || 'es'}#${dataObject.id}`;
        } else if (loginResponse !== null) {
            const msgProcessLoginCore = processResponseLoginCore({
                "msg": loginResponse.msg,
                "msgParams": loginResponse,
                "TexTranslate": TexTranslate,
                "intl": intl
            });
            hideLoader();
            if (msgProcessLoginCore) {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: msgProcessLoginCore,
                        typeMessage: "warning",
                        showCancelButton: false,
                        intl
                    }
                );
            } else {
                console.log(loginResponse);
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Error", "general.Error"),
                        message: TexTranslate(intl, "general.Error", "general.Error"),
                        typeMessage: "error",
                        showCancelButton: false,
                        intl
                    }
                );
            }
        }
    }

    const createMenuModules = ({ idMenu, idSubMenu, principalMenu, dataServicios, handlerClickMenu,
        onEnventClickVert }) => {
        const menuBack = <VerticalMenuItem key="menuBack" id="menuBack" typeIcon={"back"}
            link={null} handlerClick={(e) => { handlerClickMenu(e,"menuDashboard"); onEnventClickVert("menuDashboard");}}
            active={idMenu === "menuBack"} tooltip={TexTranslate(intl, "general.Back")} />;

        const menuDashboard = <VerticalMenuItem key="menuDashboard" id="menuDashboard"
            typeIcon={"houseFill"} handlerClick={(e) => {
                handlerClickMenu(e,"menuDashboard");
                onEnventClickVert("menuDashboard");
            }} active={idMenu === "menuDashboard"}
            link={'/dashboardAdmin'} tooltip={TexTranslate(intl, "general.Init")} />;

        const listMenu = [];

        !principalMenu && listMenu.push(menuBack);
        listMenu.push(menuDashboard);

        if (dataServicios !== null && dataServicios.length > 0) {
            //Menu Principal
            const menuProvider =
                isGroupMenu(dataServicios, "P") &&
                <VerticalMenuItem key="menuProviders" id="menuProviders" typeIcon={"shop"}
                    link={null} handlerClick={(e) => { handlerClickMenu(e,"menuProviders"); onEnventClickVert("menuProviders"); }}
                    active={idMenu === "menuProviders"}
                    tooltip={TexTranslate(intl, "general.Providers")} />;

            const menuClients =
                isGroupMenu(dataServicios, "C") &&
                <VerticalMenuItem key="menuClients" id="menuClients" typeIcon={"shop-window"}
                    link={null} handlerClick={(e) => { handlerClickMenu(e,"menuClients"); onEnventClickVert("menuClients"); }}
                    active={idMenu === "menuClients"}
                    tooltip={TexTranslate(intl, "general.Clients")} />;

            const menuTools =
                isGroupMenu(dataServicios, "A") &&
                <VerticalMenuItem key="menuTools" id="menuTools" typeIcon={"tools"}
                    link={null} handlerClick={(e) => { handlerClickMenu(e,"menuTools"); onEnventClickVert("menuTools");}}
                    active={idMenu === "menuTools"}
                    tooltip={TexTranslate(intl, "general.Tools")} />;

            //SubMenu Providers
            const menuSubFinance =
                isSubGroupMenu(dataServicios, "P", "FI") &&
                <VerticalMenuItem key="menuSubFinance" id="menuSubFinance" typeIcon={"dollar"}
                    link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuProviders", "menuSubFinance");
                    }}
                    active={idSubMenu === "menuSubFinance"}
                    tooltip={TexTranslate(intl, "general.Finances")}
                    menu={createListMenu(dataServicios, "P", "FI",
                        TexTranslate(intl, "general.Finances"),handlerClickMenu)} />

            const menuSubPurchase =
                isSubGroupMenu(dataServicios, "P", "MM") &&
                <VerticalMenuItem key="menuSubPurchase" id="menuSubPurchase" typeIcon={"bagFill"}
                    link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuProviders", "menuSubPurchase");
                    }}
                    active={idSubMenu === "menuSubPurchase"}
                    tooltip={TexTranslate(intl, "general.Purchase")}
                    menu={createListMenu(dataServicios, "P", "MM",
                        TexTranslate(intl, "general.Purchase"),handlerClickMenu)} />

            const menuSubTaxes =
                isSubGroupMenu(dataServicios, "P", "TX") &&
                <VerticalMenuItem key="menuSubTaxes" id="menuSubTaxes" typeIcon={"taxes"}
                    link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuProviders", "menuSubTaxes");
                    }}
                    active={idSubMenu === "menuSubTaxes"}
                    tooltip={TexTranslate(intl, "general.Taxes")}
                    menu={createListMenu(dataServicios, "P", "TX",
                        TexTranslate(intl, "general.Taxes"),handlerClickMenu)} />

            const menuSubSolutions =
                isSubGroupMenu(dataServicios, "P", "IS") &&
                <VerticalMenuItem key="menuSubSolutions" id="menuSubSolutions"
                    typeIcon={"ui-checks-grid"} link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuProviders", "menuSubSolutions");
                    }}
                    active={idSubMenu === "menuSubSolutions"}
                    tooltip={TexTranslate(intl, "general.Solutions")}
                    menu={createListMenu(dataServicios, "P", "IS",
                        TexTranslate(intl, "general.Solutions"),handlerClickMenu)} />

            //SubMenu Clients
            const menuSubCER =
                isSubGroupMenu(dataServicios, "C", "CER") &&
                <VerticalMenuItem key="menuSubCER" id="menuSubCER" typeIcon={"taxes"}
                    link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuClients", "menuSubCER");
                    }}
                    active={idSubMenu === "menuSubCER"}
                    tooltip={TexTranslate(intl, "general.CER")}
                    menu={createListMenu(dataServicios, "C", "CER",
                        TexTranslate(intl, "general.CER"),handlerClickMenu)} />

            const menuSubClients =
                isSubGroupMenu(dataServicios, "C", "SD") &&
                <VerticalMenuItem key="menuSubClients" id="menuSubClients" typeIcon={"person-fill"}
                    link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuClients", "menuSubClients");
                    }}
                    active={idSubMenu === "menuSubClients"}
                    tooltip={TexTranslate(intl, "general.ClientsCli")}
                    menu={createListMenu(dataServicios, "C", "SD",
                        TexTranslate(intl, "general.ClientsCli"),handlerClickMenu)} />

            const menuSubFinanceCli =
                isSubGroupMenu(dataServicios, "C", "FI") &&
                <VerticalMenuItem key="menuSubFinanceCli" id="menuSubFinanceCli"
                    typeIcon={"dollar"} link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuClients", "menuSubFinanceCli");
                    }}
                    active={idSubMenu === "menuSubFinanceCli"}
                    tooltip={TexTranslate(intl, "general.FinancesCli")}
                    menu={createListMenu(dataServicios, "C", "FI",
                        TexTranslate(intl, "general.FinancesCli"),handlerClickMenu)} />

            //SubMenu Tools
            const menuSubProfiles =
                isSubGroupMenu(dataServicios, "A", "ROL") &&
                <VerticalMenuItem key="menuSubProfiles" id="menuSubProfiles"
                    typeIcon={"people-fill"} link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuTools", "menuSubProfiles");
                    }}
                    active={idSubMenu === "menuSubProfiles"}
                    tooltip={TexTranslate(intl, "general.Profiles")}
                    menu={createListMenu(dataServicios, "A", "ROL",
                        TexTranslate(intl, "general.Profiles"),handlerClickMenu)} />

            const menuSubStatistics =
                isSubGroupMenu(dataServicios, "A", "EST") &&
                <VerticalMenuItem key="menuSubStatistics" id="menuSubStatistics"
                    typeIcon={"bar-chart-fill"} link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuTools", "menuSubStatistics");
                    }}
                    active={idSubMenu === "menuSubStatistics"}
                    tooltip={TexTranslate(intl, "general.Statistics")}
                    menu={createListMenu(dataServicios, "A", "EST",
                        TexTranslate(intl, "general.Statistics"),handlerClickMenu)} />

            const menuSubTools =
                isSubGroupMenu(dataServicios, "A", "HER") &&
                <VerticalMenuItem key="menuSubTools" id="menuSubTools"
                    typeIcon={"wrench-adjustable"} link={null} handlerClick={(e) => {
                        handlerClickMenu(e,"menuTools", "menuSubTools");
                    }}
                    active={idSubMenu === "menuSubTools"}
                    tooltip={TexTranslate(intl, "general.Tools")}
                    menu={createListMenu(dataServicios, "A", "HER",
                        TexTranslate(intl, "general.Tools"),handlerClickMenu)} />

            //Menu Principal
            menuProvider && principalMenu && listMenu.push(menuProvider);
            menuClients && principalMenu && listMenu.push(menuClients);
            menuTools && principalMenu && listMenu.push(menuTools);

            //SubMenu Providers
            menuSubFinance && !principalMenu && idMenu === "menuProviders"
                && listMenu.push(menuSubFinance);
            menuSubPurchase && !principalMenu && idMenu === "menuProviders"
                && listMenu.push(menuSubPurchase);
            menuSubTaxes && !principalMenu && idMenu === "menuProviders"
                && listMenu.push(menuSubTaxes);
            menuSubSolutions && !principalMenu && idMenu === "menuProviders"
                && listMenu.push(menuSubSolutions);

            //SubMenu Clients
            menuSubCER && !principalMenu && idMenu === "menuClients"
                && listMenu.push(menuSubCER);
            menuSubClients && !principalMenu && idMenu === "menuClients"
                && listMenu.push(menuSubClients);
            menuSubFinanceCli && !principalMenu && idMenu === "menuClients"
                && listMenu.push(menuSubFinanceCli);

            //SubMenu Tools
            menuSubProfiles && !principalMenu && idMenu === "menuTools"
                && listMenu.push(menuSubProfiles);
            menuSubStatistics && !principalMenu && idMenu === "menuTools"
                && listMenu.push(menuSubStatistics);
            menuSubTools && !principalMenu && idMenu === "menuTools"
                && listMenu.push(menuSubTools);

        }

        return (
            listMenu
        );
    };

    return { selectMenu, createListMenu, createMenuModules, processLoginCoreMenu
    
    }

}

export const useMenuPerfil = ({ intl, user, setCompanyChange }) => {

    const txtLoad = TexTranslateDefault(intl, "general.Loading...");
    const {showLoader, hideLoader} = useLoader({"textLoader" : txtLoad});

    const createListMenuPerfil = (dataEmpresas, tittle, handlerClickMenu, showMinSideMenu) => {

        const linkProfile = <ul key={"pm-1"} ><li><Link id={"changePasword"} to={"/profile"}>
            {TexTranslateDefault(intl, "perfil.Change Password")}
        </Link></li></ul>;

        const dataSelect = [];
        const defaultValue = [];
        if(dataEmpresas !== null && dataEmpresas.length > 0) {
            for(let i = 0; i < dataEmpresas.length; i++){
                const opt = {
                    "label" : dataEmpresas[i].empresa, 
                    "value" : dataEmpresas[i].keyClient,
                    "data" : dataEmpresas[i]
                };
                if(user.nit === dataEmpresas[i].nit && user.idPais === dataEmpresas[i].pais){
                    defaultValue.push(dataEmpresas[i].keyClient);
                }
                dataSelect.push(opt);
            }
        }

        const handleChangeSelect = (e) => {
            showLoader();
            try{
                const value = e.target.value;
                const dataObject = JSON.parse(e.target.options[e.target.selectedIndex].dataset.object);
                const changeCompanyObj = {
                    "keyClient": value,
                    "nit": dataObject.nit,
                    "pais": dataObject.pais,
                    "empresa": dataObject.empresa
                }
                setCompanyChange(changeCompanyObj);
            } catch(e){
                hideLoader();
            }
        }

        const select = dataSelect.length > 1
            && <Select id="selectCompany" data={dataSelect} handleChangeSelect={handleChangeSelect} 
                defaultValue={defaultValue[0]} />

        const opcionCambiarEmpresa = select && {
            "id" : "changeCompany",
            "text": `${TexTranslateDefault(intl, "perfil.Company Change")}:`,
            "action" : "changeCompany",
            "component" : select
        };

        const handleClickListItem = (e) => {
            let listItem = e.target;
            if (listItem.dataset.object === undefined) {
                listItem = listItem.parentElement;
            }
            const dataObject = JSON.parse(listItem.dataset.object);
            if(dataObject.action === "changePasword"){

            } else if(dataObject.action === "changeCompany"){

            }

        };

        const menuComponent = [];
        menuComponent.push(linkProfile);
        opcionCambiarEmpresa && menuComponent.push(<div key={"pm-2"}  style={{minHeight : 10}}/>);
        opcionCambiarEmpresa && menuComponent.push(<List key={"pm-3"} arrayItems={[opcionCambiarEmpresa]} 
            handleClickListItem={(e)=> {handleClickListItem(e);}} />);

        const result = {
            "text": tittle,
            "content": menuComponent,
            "clicMenu" : handlerClickMenu,
            "showMenu" : showMinSideMenu
        };

        return result;
    };

    return {
        createListMenuPerfil
    };


}

export const isGroupMenu = (data, group) => {
    return data.filter(obj => obj.grupo === group).length > 0;
}

export const getSubGroupMenu = (data, group, subGroup) => {
    return data.filter(obj => obj.grupo === group && obj.subCodserv === subGroup);
}

export const isSubGroupMenu = (data, group, subGroup) => {
    return getSubGroupMenu(data, group, subGroup).length > 0;
}
